import styled from "styled-components";

export const Container = styled.div`
  background: transparent linear-gradient(180deg, #F2F8FC 0%, #FFFFFF 100%) 0% 0% no-repeat padding-box;
`
